import * as routerNames from '@/services/router/router.names'

import Dashboard from '@/screens/dashboard/dashboard.vue'

export default [
  {
    path: '/:accountId/home',
    name: routerNames.DASHBOARD,
    component: Dashboard,
  },
]
